export default {
  NOTIFICATION_SETTINGS: {
    TITLE: `Mes paramètres de notification`,
    SUMMARY: `Les paramètres suivants déterminent les personnes qui recevront une notification par courriel lors d'un événement spécifique. Certains types de notifications vous permettent de choisir d'être contacté par SMS plutôt que par courriel.`
  },
  NOTIFICATION_METHOD: `Méthode de notification`,
  REMINDERS_MODULE: `Module des rappels`,
  ATTENDANCE_MODULE: `Module d'absences`,
  TIMEOFF_MODULE: `Module de congés`,
  VACATION_CHOICES_MODULE: `Module de choix de vacances`,
  AVAILABILITY_MODULE: `Module de disponibilités`,
  PROJECT_MODULE: `Module de projets`,
  DISABLESHIFTNOTIFICATIONS: {
    LABEL: `Désactiver les rappels de quarts`,
    DESCRIPTION: `Les rappels de quarts sont normalement envoyés en soirée pour les quarts du lendemain.`
  },
  DISABLEAVAILABILITIESCUTOFFDATEREMINDER: {
    LABEL: `Désactiver les rappels de soumission des disponibilités`,
    DESCRIPTION: `Le rappels de soumission des disponibilités sont envoyés entre 3 et 4 heures avant l'heure limite.`
  },
  OPTIONS: {
    none: `Aucun`,
    me: `Moi`,
    team: `Mes équipes`,
    project: `Mes projets`,
    teamAndProject: `Mes équipes & Mes projets`,
    all: `Tout m'envoyer`,
    email: `Courriel`,
    sms: `SMS`
  },
  NOTIFICATION_CATEGORIES: {
    create: `Créée`,
    update: `Modifiée`,
    delete: `Supprimée`,
    daytodayChanges: `Rotation quotidienne des employés`
  },
  NOTIFICATION_DESCRIPTIONS: {
    PROJECT_MODULE: {
      daytodayChanges: `En tant que responsable de projet, vous recevrez une liste des employés qui ont été ajoutés ou supprimés de votre projet depuis hier.`
    }
  }
}
